export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail eller brugernavn',
      invalidEmailOrUsername: 'Ugyldig e-mail eller brugernavn',
      invalidPassword: 'Ugyldig løsen',
      noInternetConnection: 'Ingen forbindelse til internettet',
      pageNotFound_title: 'Side ej fundet',
      password: 'Løsen',
      projectManagement: 'Projektstyring',
      serverConnectionFailed: 'Ingen forbindelse til serveren',
      unknownError: 'Ukendt fejl - prøv igen',
    },

    action: {
      logIn: 'Log på',
    },
  },
};
